import { ChangeDetectorRef, Directive, ElementRef, Input, NgZone, OnInit } from '@angular/core';
import { TooltipService } from '@shared/directives/tooltip/tooltip.service';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TooltipPosition, TooltipTheme } from './tooltip.enums';

@Directive({
  selector: '[tooltip]'
})
export class Tooltip2Directive implements OnInit {
  @Input() tooltip = '';
  @Input() position: TooltipPosition = TooltipPosition.DEFAULT;
  @Input() theme: TooltipTheme = TooltipTheme.DEFAULT;
  @Input() showDelay = 0;
  @Input() hideDelay = 0;

  @Input() skipHeight = false;

  private showTimeout?: number;
  private hideTimeout?: number;
  private touchTimeout?: number;

  mouseenter$;
  mouseleave$;
  mousemove$;

  private _destroyed = new Subject();

  constructor(
    private _elementRef: ElementRef,
    private _cdr: ChangeDetectorRef,
    private _zone: NgZone,
    private _tooltipService: TooltipService
  ) {}

  ngOnInit() {
    this._zone.runOutsideAngular(() => {
      this.mouseenter$ = fromEvent<MouseEvent>(this._elementRef.nativeElement, 'mouseenter')
        .pipe(takeUntil(this._destroyed))
        .subscribe((event) => {
          this.initializeTooltip(event);
        });

      this.mouseleave$ = fromEvent<MouseEvent>(this._elementRef.nativeElement, 'mouseleave')
        .pipe(takeUntil(this._destroyed))
        .subscribe(() => {
          this.setHideTooltipTimeout();
        });
    });
  }

  // @HostListener('mousemove', ['$event'])
  // onMouseMove($event: MouseEvent): void {
  //   if (this.componentRef !== null && this.position === TooltipPosition.DYNAMIC) {
  //     this.componentRef.instance.left = $event.clientX;
  //     this.componentRef.instance.top = $event.clientY;
  //     this.componentRef.instance.tooltip = this.tooltip;
  //   }
  // }

  // @HostListener('touchstart', ['$event'])
  // onTouchStart($event: TouchEvent): void {
  //   $event.preventDefault();
  //   window.clearTimeout(this.touchTimeout);
  //   this.touchTimeout = window.setTimeout(this.initializeTooltip.bind(this), 500);
  // }

  // @HostListener('touchend')
  // onTouchEnd(): void {
  //   window.clearTimeout(this.touchTimeout);
  //   this.setHideTooltipTimeout();
  // }

  private initializeTooltip(event) {
    const position = this.setTooltipComponentProperties();
    const hostHeight = this._elementRef.nativeElement.offsetHeight;

    let bottomPosition = hostHeight ? hostHeight + 5 : 5;

    if (this.skipHeight) {
      bottomPosition = 10;
    }

    position.top = event.clientY - 20;

    if (this.position === TooltipPosition.BELOW) {
      position.top = event.clientY + bottomPosition;
    }

    position.left = event.clientX;
    position.tooltip = this.tooltip;
    position.visible = true;
    position['position'] = this.position;

    this._tooltipService.setReloadTooltip(position);
  }

  private setTooltipComponentProperties() {
    const { left, right, top, bottom } = this._elementRef.nativeElement.getBoundingClientRect();

    const position = {
      left,
      right,
      top,
      bottom,
      visible: true,
      tooltip: this.tooltip
    };

    switch (this.position) {
      case TooltipPosition.BELOW: {
        position.left = Math.round((right - left) / 2 + left);
        position.top = Math.round(bottom);
        break;
      }
      case TooltipPosition.ABOVE: {
        position.left = Math.round((right - left) / 2 + left);
        position.top = Math.round(top);
        break;
      }
      case TooltipPosition.RIGHT: {
        position.left = Math.round(right);
        position.top = Math.round(top + (bottom - top) / 2);
        break;
      }
      case TooltipPosition.LEFT: {
        position.left = Math.round(left);
        position.top = Math.round(top + (bottom - top) / 2);
        break;
      }
      default: {
        break;
      }
    }

    return position;
  }

  private setHideTooltipTimeout() {
    const position = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      visible: false
    };
    this._tooltipService.setReloadTooltip(position);
  }

  ngOnDestroy(): void {
    this.setHideTooltipTimeout();
    this.destroy();
    this.mouseenter$.unsubscribe();
    this.mouseleave$.unsubscribe();
    this._destroyed.next(true);
    this._destroyed.complete();
  }

  destroy(): void {
    window.clearInterval(this.showTimeout);
    window.clearInterval(this.hideDelay);
  }
}
